(function(){
  window.dfApi = {

    /**
     * Responsible for generating a random unique id
     * @returns {string} - the generated uuid
     */
    uuidv4: function (){
      return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
      );
    },

    /**
     * Responsible for returning a value from local storage
     * @param {string} key - the key name
     * @return {null|object} - null if not set, object if set
     */
    getLocalStorage: function(key){
      return JSON.parse(window.localStorage.getItem(key));
    },

    /**
     * Responsible for saving a value to local storage
     * @param {string} key - the key name
     * @param {string|Array} value - the value for the key to be stored
     */
    updateLocalStorage: function(key, value){
      window.localStorage.setItem(key, JSON.stringify(value));
    },

    /**
     * Responsible for returning a cookie value
     * @param {string} key - the key name
     * @return {null|object} - null if not set, object if set
     */
    getCookie: function(key){
      let name = key + "=";
      let ca = document.cookie.split(';');
      for(let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
          return JSON.parse(c.substring(name.length, c.length));
        }
      }
      return null;
    },

    /**
     * Responsible setting a cookie
     * @param {string} key - the key name
     * @param {string|Array} value - the value for the key to be stored
     * @param {number} days - Amount of days before the cookie expires (defaults to a year)
     */
    updateCookie: function(key, value, days = 365){
      const d = new Date();
      d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
      let expires = "expires="+d.toUTCString();
      document.cookie = key + "=" + JSON.stringify(value) + ";" + expires + ";path=/";
    },

    /**
     * Responsible deleting a cookie
     * @param {string} key - the key name
     */
    deleteCookie: function(key){
      document.cookie = key+'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    },

    /**
     * Responsible for getting a single param from the URL Query String
     * @param string paramName - the name of the parameter to get from the url
     * @return string|null the value of the parameter (or null if not set)
     */
    getParam: function (paramName) {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      return urlParams.get(paramName);
    },

    /**
     * Responsible for getting a list of parameters from the URL
     * @param {Array} paramsArr - the list of paramter names to get from the url
     * @return {{}} an object of the matching parameter names and values
     */
    getParams: function (paramsArr) {
      let results = {};
      let tmp = [];
      // Query params for a URL, including ?
      const arr = window.location.search
        .substr(1)
        .split("&");
      for (let i = 0; i < arr.length; i++) {
        tmp = arr[i].split("=");
        if (paramsArr.indexOf(tmp[0]) > -1) {
          results[tmp[0]] = decodeURIComponent(tmp[1]);
        }
      }
      return results;
    },

    /**
     * @param {Object} object
     * @return {string}
     */
    toFormUrlEncoded: function (object) {
      return Object.entries(object)
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
        .join('&');
    },

    /**
     * Responsible for getting the query parameters from a URL
     * @returns {{}|null} an object containing the list of key values
     * found withing window.location.search or null when no query params
     * are existent.
     */
    getURLQueryParams: function (filters){
      let params = window.location.search
        .substr(1)
        .split("&");

      if(!params.length){
        return null;
      }

      // Get each parameter in the URL by key/value
      let paramsKeyStore = {};
      params.forEach((keyValue) => {
        // Make sure the value in the URL is a valid key/value
        if(keyValue.indexOf('=') > -1){
          const keyValueStore = keyValue.split('=');
          if(filters === undefined || filters.indexOf(keyValueStore[0]) > -1){
            paramsKeyStore[keyValueStore[0]] = keyValueStore[1];
          }
        }
      });

      return paramsKeyStore;
    },

    /**
     * Responsible for checking if an object has a property beyond the first level
     * Basically an extension of hasOwnProperty() for nested properties
     * @returns {bool} whether the property exists or not
     */
    hasOwnNestedProperty: function(obj, propertyPath){
      let properties = propertyPath.split('.');
      for (let i = 0; i < properties.length; i++) {
        let prop = properties[i];
        if (!obj || !obj.hasOwnProperty(prop)) {
          return false;
        } else {
          obj = obj[prop];
        }
      }
      return true;
    },

    /**
     * Responsible for copying content to the clipboard
     * @returns {bool} whether the content has been copied or not
     */
    copyToClipboard: async function(content){
      try {
        await navigator.clipboard.writeText(content);
        return true;
      } catch (err) {
        return false;
      }
    }

  }
})();